var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFailederror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FF6565;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_214",
    className: "cls-1",
    d: "M12,0C5.37,0,0,5.37,0,12c0,6.63,5.37,12,12,12,6.63,0,12-5.37,12-12S18.63,0,12,0c0,0,0,0,0,0M14.02,18.42c0,1.12-.9,2.02-2.02,2.02s-2.02-.9-2.02-2.02v-.05c0-1.12.9-2.02,2.02-2.02s2.02.9,2.02,2.02v.05ZM14.07,4.94l-1,8.74c0,.59-.48,1.07-1.07,1.07-.59,0-1.07-.48-1.07-1.07l-.99-8.75c-.13-.51.18-1.02.68-1.15.08-.02.16-.03.24-.03h2.27c.54,0,.97.45.97.99,0,0,0,0,0,0,0,.07,0,.13-.02.2h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFailederror);
export default __webpack_public_path__ + "static/media/icon_failederror.835ae281079d3987bd7b87e02b76a289.svg";
export { ForwardRef as ReactComponent };